
<mat-form-field class="no-underline" appearance="legacy" [style.width.px]="cellWidth">
  <mat-select
    [(ngModel)]="selectedValues"
    (ngModelChange)="onModelChange($event)"
    multiple
    [compareWith]="compareItems"
    (openedChange)="onOpenedChange($event)"
  >
    <!-- Select All row: ONLY a real mat-checkbox; add a class to target CSS -->
    <mat-option class="select-all-option" (click)="$event.stopPropagation()">
      <mat-checkbox
        [checked]="selectAllState === 'checked'"
        [indeterminate]="selectAllState === 'indeterminate'"
        (change)="toggleSelectAll()"
      >
        Select All
      </mat-checkbox>
    </mat-option>

    <!-- Actual options -->
    <mat-option *ngFor="let option of options" [value]="option">
           {{ option.AssemblyName }}
    </mat-option>
  </mat-select>
